import { observer } from 'mobx-react';
import { useMemo } from 'react';
import CopyToClipboardStore from '../../../../../../../../../CopyToClipboard/Store';
import CopyToClipboardReactions from '../../../../../../../../../CopyToClipboard/Store/Reactions';
import { TranslationsContext, translation } from '../../../../../../../../../../Translations';
import CopyToClipboardState from './CopyToClipboardState';

interface Props {
  copyText: string;
}

function CopyToClipboard({ copyText }: Props) {
  const copyToClipboardStore = useMemo(() => new CopyToClipboardStore(copyText), [copyText]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      copyToClipboardStore.copying();
    }
  };

  return (
    <TranslationsContext.Consumer>
      {(ts) => (
        <div
          role="button"
          tabIndex={0}
          aria-label={translation('Copy Course Link')(ts)}
          data-clipboard-text={copyText}
          className="bg-card border-1 inline-flex items-center rounded-md border-primary text-primary py-2 px-4 text-sm cursor-pointer focus:ring-2 focus:ring-ring focus:ring-offset-2"
          data-intercom-target="shareable-links-copy-course-link-button"
          onClick={() => copyToClipboardStore.copying()}
          onKeyDown={handleKeyDown}
        >
          <CopyToClipboardState
            kind={copyToClipboardStore.state.kind}
            copying={copyToClipboardStore.copying}
          />
          <CopyToClipboardReactions store={copyToClipboardStore} />
        </div>
      )}
    </TranslationsContext.Consumer>
  );
}

export default observer(CopyToClipboard);
